import { render, staticRenderFns } from "./DashboardModals.vue?vue&type=template&id=e9a70e8e&"
import script from "./DashboardModals.vue?vue&type=script&lang=js&"
export * from "./DashboardModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports